// source: pbtypes/tools/cloud_config/site_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_body_pos_yaw_pb = require('../../../pbtypes/gen/body/pos_yaw_pb.js');
goog.object.extend(proto, pbtypes_gen_body_pos_yaw_pb);
var pbtypes_gen_eigen_lcm_Vector3f_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3f_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3f_pb);
var pbtypes_util_geofence_geofence_pb = require('../../../pbtypes/util/geofence/geofence_pb.js');
goog.object.extend(proto, pbtypes_util_geofence_geofence_pb);
var pbtypes_util_pathfinder_pathfinder_metadata_pb = require('../../../pbtypes/util/pathfinder/pathfinder_metadata_pb.js');
goog.object.extend(proto, pbtypes_util_pathfinder_pathfinder_metadata_pb);
var pbtypes_vehicle_infrastructure_flight_deck_return_settings_pb = require('../../../pbtypes/vehicle/infrastructure/flight_deck/return_settings_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_return_settings_pb);
var pbtypes_vehicle_skills_waypoints_pb = require('../../../pbtypes/vehicle/skills/waypoints_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_waypoints_pb);
goog.exportSymbol('proto.cloud_config.GeofenceEnforcement', null, global);
goog.exportSymbol('proto.cloud_config.GeofenceLayer', null, global);
goog.exportSymbol('proto.cloud_config.GeofenceLock', null, global);
goog.exportSymbol('proto.cloud_config.GeofenceLock.Enum', null, global);
goog.exportSymbol('proto.cloud_config.SafeLandingPoint', null, global);
goog.exportSymbol('proto.cloud_config.SiteInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_config.SiteInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud_config.SiteInfo.repeatedFields_, null);
};
goog.inherits(proto.cloud_config.SiteInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_config.SiteInfo.displayName = 'proto.cloud_config.SiteInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_config.SafeLandingPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_config.SafeLandingPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_config.SafeLandingPoint.displayName = 'proto.cloud_config.SafeLandingPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_config.GeofenceLock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_config.GeofenceLock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_config.GeofenceLock.displayName = 'proto.cloud_config.GeofenceLock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_config.GeofenceEnforcement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_config.GeofenceEnforcement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_config.GeofenceEnforcement.displayName = 'proto.cloud_config.GeofenceEnforcement';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud_config.SiteInfo.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_config.SiteInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_config.SiteInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_config.SiteInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.SiteInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
siteTNcpgByNcpgIdMap: (f = msg.getSiteTNcpgByNcpgIdMap()) ? f.toObject(includeInstance, proto.body.PosYawPb.toObject) : [],
estimateSiteTNavTakeoff: (f = msg.getEstimateSiteTNavTakeoff()) && pbtypes_gen_body_pos_yaw_pb.PosYawPb.toObject(includeInstance, f),
geofence: (f = msg.getGeofence()) && pbtypes_util_geofence_geofence_pb.Geofence.toObject(includeInstance, f),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
gpsOrigin: (f = msg.getGpsOrigin()) && pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb.toObject(includeInstance, f),
safeLandingPointsList: jspb.Message.toObjectList(msg.getSafeLandingPointsList(),
    proto.cloud_config.SafeLandingPoint.toObject, includeInstance),
pathfinderDataFileId: jspb.Message.getFieldWithDefault(msg, 7, ""),
pathfinderMetadata: (f = msg.getPathfinderMetadata()) && pbtypes_util_pathfinder_pathfinder_metadata_pb.PathfinderArtifactMetadata.toObject(includeInstance, f),
fileToGeofenceLayerMap: (f = msg.getFileToGeofenceLayerMap()) ? f.toObject(includeInstance, undefined) : [],
fileToGeofenceEnforcementMap: (f = msg.getFileToGeofenceEnforcementMap()) ? f.toObject(includeInstance, proto.cloud_config.GeofenceEnforcement.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_config.SiteInfo}
 */
proto.cloud_config.SiteInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_config.SiteInfo;
  return proto.cloud_config.SiteInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_config.SiteInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_config.SiteInfo}
 */
proto.cloud_config.SiteInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getSiteTNcpgByNcpgIdMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.body.PosYawPb.deserializeBinaryFromReader, "", new proto.body.PosYawPb());
         });
      break;
    case 2:
      var value = new pbtypes_gen_body_pos_yaw_pb.PosYawPb;
      reader.readMessage(value,pbtypes_gen_body_pos_yaw_pb.PosYawPb.deserializeBinaryFromReader);
      msg.setEstimateSiteTNavTakeoff(value);
      break;
    case 3:
      var value = new pbtypes_util_geofence_geofence_pb.Geofence;
      reader.readMessage(value,pbtypes_util_geofence_geofence_pb.Geofence.deserializeBinaryFromReader);
      msg.setGeofence(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 5:
      var value = new pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb.deserializeBinaryFromReader);
      msg.setGpsOrigin(value);
      break;
    case 6:
      var value = new proto.cloud_config.SafeLandingPoint;
      reader.readMessage(value,proto.cloud_config.SafeLandingPoint.deserializeBinaryFromReader);
      msg.addSafeLandingPoints(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPathfinderDataFileId(value);
      break;
    case 9:
      var value = new pbtypes_util_pathfinder_pathfinder_metadata_pb.PathfinderArtifactMetadata;
      reader.readMessage(value,pbtypes_util_pathfinder_pathfinder_metadata_pb.PathfinderArtifactMetadata.deserializeBinaryFromReader);
      msg.setPathfinderMetadata(value);
      break;
    case 8:
      var value = msg.getFileToGeofenceLayerMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readEnum, null, "", 0);
         });
      break;
    case 10:
      var value = msg.getFileToGeofenceEnforcementMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.cloud_config.GeofenceEnforcement.deserializeBinaryFromReader, "", new proto.cloud_config.GeofenceEnforcement());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_config.SiteInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_config.SiteInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_config.SiteInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.SiteInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteTNcpgByNcpgIdMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getSiteTNcpgByNcpgIdMap(true),
    1,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.body.PosYawPb.serializeBinaryToWriter);
  }
  f = message.getEstimateSiteTNavTakeoff();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_body_pos_yaw_pb.PosYawPb.serializeBinaryToWriter
    );
  }
  f = message.getGeofence();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_util_geofence_geofence_pb.Geofence.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGpsOrigin();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb.serializeBinaryToWriter
    );
  }
  f = message.getSafeLandingPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.cloud_config.SafeLandingPoint.serializeBinaryToWriter
    );
  }
  f = message.getPathfinderDataFileId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPathfinderMetadata();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      pbtypes_util_pathfinder_pathfinder_metadata_pb.PathfinderArtifactMetadata.serializeBinaryToWriter
    );
  }
  f = message.getFileToGeofenceLayerMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getFileToGeofenceLayerMap(true),
    8,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeEnum);
  }
  f = message.getFileToGeofenceEnforcementMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getFileToGeofenceEnforcementMap(true),
    10,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.cloud_config.GeofenceEnforcement.serializeBinaryToWriter);
  }
};


/**
 * map<string, body.PosYawPb> site_T_ncpg_by_ncpg_id = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.body.PosYawPb>}
 */
proto.cloud_config.SiteInfo.prototype.getSiteTNcpgByNcpgIdMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.body.PosYawPb>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.body.PosYawPb));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.clearSiteTNcpgByNcpgIdMap = function() {
  this.getSiteTNcpgByNcpgIdMap().clear();
  return this;
};


/**
 * optional body.PosYawPb estimate_site_T_nav_takeoff = 2;
 * @return {?proto.body.PosYawPb}
 */
proto.cloud_config.SiteInfo.prototype.getEstimateSiteTNavTakeoff = function() {
  return /** @type{?proto.body.PosYawPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_body_pos_yaw_pb.PosYawPb, 2));
};


/**
 * @param {?proto.body.PosYawPb|undefined} value
 * @return {!proto.cloud_config.SiteInfo} returns this
*/
proto.cloud_config.SiteInfo.prototype.setEstimateSiteTNavTakeoff = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.clearEstimateSiteTNavTakeoff = function() {
  return this.setEstimateSiteTNavTakeoff(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.SiteInfo.prototype.hasEstimateSiteTNavTakeoff = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional geofence.Geofence geofence = 3;
 * @return {?proto.geofence.Geofence}
 */
proto.cloud_config.SiteInfo.prototype.getGeofence = function() {
  return /** @type{?proto.geofence.Geofence} */ (
    jspb.Message.getWrapperField(this, pbtypes_util_geofence_geofence_pb.Geofence, 3));
};


/**
 * @param {?proto.geofence.Geofence|undefined} value
 * @return {!proto.cloud_config.SiteInfo} returns this
*/
proto.cloud_config.SiteInfo.prototype.setGeofence = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.clearGeofence = function() {
  return this.setGeofence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.SiteInfo.prototype.hasGeofence = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.cloud_config.SiteInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional eigen_lcm.Vector3fPb gps_origin = 5;
 * @return {?proto.eigen_lcm.Vector3fPb}
 */
proto.cloud_config.SiteInfo.prototype.getGpsOrigin = function() {
  return /** @type{?proto.eigen_lcm.Vector3fPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb, 5));
};


/**
 * @param {?proto.eigen_lcm.Vector3fPb|undefined} value
 * @return {!proto.cloud_config.SiteInfo} returns this
*/
proto.cloud_config.SiteInfo.prototype.setGpsOrigin = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.clearGpsOrigin = function() {
  return this.setGpsOrigin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.SiteInfo.prototype.hasGpsOrigin = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated SafeLandingPoint safe_landing_points = 6;
 * @return {!Array<!proto.cloud_config.SafeLandingPoint>}
 */
proto.cloud_config.SiteInfo.prototype.getSafeLandingPointsList = function() {
  return /** @type{!Array<!proto.cloud_config.SafeLandingPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud_config.SafeLandingPoint, 6));
};


/**
 * @param {!Array<!proto.cloud_config.SafeLandingPoint>} value
 * @return {!proto.cloud_config.SiteInfo} returns this
*/
proto.cloud_config.SiteInfo.prototype.setSafeLandingPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.cloud_config.SafeLandingPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud_config.SafeLandingPoint}
 */
proto.cloud_config.SiteInfo.prototype.addSafeLandingPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.cloud_config.SafeLandingPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.clearSafeLandingPointsList = function() {
  return this.setSafeLandingPointsList([]);
};


/**
 * optional string pathfinder_data_file_id = 7;
 * @return {string}
 */
proto.cloud_config.SiteInfo.prototype.getPathfinderDataFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.setPathfinderDataFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional pathfinder.PathfinderArtifactMetadata pathfinder_metadata = 9;
 * @return {?proto.pathfinder.PathfinderArtifactMetadata}
 */
proto.cloud_config.SiteInfo.prototype.getPathfinderMetadata = function() {
  return /** @type{?proto.pathfinder.PathfinderArtifactMetadata} */ (
    jspb.Message.getWrapperField(this, pbtypes_util_pathfinder_pathfinder_metadata_pb.PathfinderArtifactMetadata, 9));
};


/**
 * @param {?proto.pathfinder.PathfinderArtifactMetadata|undefined} value
 * @return {!proto.cloud_config.SiteInfo} returns this
*/
proto.cloud_config.SiteInfo.prototype.setPathfinderMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.clearPathfinderMetadata = function() {
  return this.setPathfinderMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.SiteInfo.prototype.hasPathfinderMetadata = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * map<string, GeofenceLayer> file_to_geofence_layer = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.cloud_config.GeofenceLayer>}
 */
proto.cloud_config.SiteInfo.prototype.getFileToGeofenceLayerMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.cloud_config.GeofenceLayer>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.clearFileToGeofenceLayerMap = function() {
  this.getFileToGeofenceLayerMap().clear();
  return this;
};


/**
 * map<string, GeofenceEnforcement> file_to_geofence_enforcement = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.cloud_config.GeofenceEnforcement>}
 */
proto.cloud_config.SiteInfo.prototype.getFileToGeofenceEnforcementMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.cloud_config.GeofenceEnforcement>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      proto.cloud_config.GeofenceEnforcement));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud_config.SiteInfo} returns this
 */
proto.cloud_config.SiteInfo.prototype.clearFileToGeofenceEnforcementMap = function() {
  this.getFileToGeofenceEnforcementMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_config.SafeLandingPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_config.SafeLandingPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_config.SafeLandingPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.SafeLandingPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
position: (f = msg.getPosition()) && pbtypes_vehicle_skills_waypoints_pb.PositionXY.toObject(includeInstance, f),
height: (f = msg.getHeight()) && pbtypes_vehicle_skills_waypoints_pb.PositionZ.toObject(includeInstance, f),
returnSettings: (f = msg.getReturnSettings()) && pbtypes_vehicle_infrastructure_flight_deck_return_settings_pb.ReturnSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_config.SafeLandingPoint}
 */
proto.cloud_config.SafeLandingPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_config.SafeLandingPoint;
  return proto.cloud_config.SafeLandingPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_config.SafeLandingPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_config.SafeLandingPoint}
 */
proto.cloud_config.SafeLandingPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUuid(value);
      break;
    case 2:
      var value = new pbtypes_vehicle_skills_waypoints_pb.PositionXY;
      reader.readMessage(value,pbtypes_vehicle_skills_waypoints_pb.PositionXY.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 3:
      var value = new pbtypes_vehicle_skills_waypoints_pb.PositionZ;
      reader.readMessage(value,pbtypes_vehicle_skills_waypoints_pb.PositionZ.deserializeBinaryFromReader);
      msg.setHeight(value);
      break;
    case 4:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_return_settings_pb.ReturnSettings;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_return_settings_pb.ReturnSettings.deserializeBinaryFromReader);
      msg.setReturnSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_config.SafeLandingPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_config.SafeLandingPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_config.SafeLandingPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.SafeLandingPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_vehicle_skills_waypoints_pb.PositionXY.serializeBinaryToWriter
    );
  }
  f = message.getHeight();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_vehicle_skills_waypoints_pb.PositionZ.serializeBinaryToWriter
    );
  }
  f = message.getReturnSettings();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_return_settings_pb.ReturnSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.cloud_config.SafeLandingPoint.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_config.SafeLandingPoint} returns this
 */
proto.cloud_config.SafeLandingPoint.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional skills.PositionXY position = 2;
 * @return {?proto.skills.PositionXY}
 */
proto.cloud_config.SafeLandingPoint.prototype.getPosition = function() {
  return /** @type{?proto.skills.PositionXY} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_waypoints_pb.PositionXY, 2));
};


/**
 * @param {?proto.skills.PositionXY|undefined} value
 * @return {!proto.cloud_config.SafeLandingPoint} returns this
*/
proto.cloud_config.SafeLandingPoint.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.SafeLandingPoint} returns this
 */
proto.cloud_config.SafeLandingPoint.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.SafeLandingPoint.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional skills.PositionZ height = 3;
 * @return {?proto.skills.PositionZ}
 */
proto.cloud_config.SafeLandingPoint.prototype.getHeight = function() {
  return /** @type{?proto.skills.PositionZ} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_waypoints_pb.PositionZ, 3));
};


/**
 * @param {?proto.skills.PositionZ|undefined} value
 * @return {!proto.cloud_config.SafeLandingPoint} returns this
*/
proto.cloud_config.SafeLandingPoint.prototype.setHeight = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.SafeLandingPoint} returns this
 */
proto.cloud_config.SafeLandingPoint.prototype.clearHeight = function() {
  return this.setHeight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.SafeLandingPoint.prototype.hasHeight = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional flight_deck.ReturnSettings return_settings = 4;
 * @return {?proto.flight_deck.ReturnSettings}
 */
proto.cloud_config.SafeLandingPoint.prototype.getReturnSettings = function() {
  return /** @type{?proto.flight_deck.ReturnSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_return_settings_pb.ReturnSettings, 4));
};


/**
 * @param {?proto.flight_deck.ReturnSettings|undefined} value
 * @return {!proto.cloud_config.SafeLandingPoint} returns this
*/
proto.cloud_config.SafeLandingPoint.prototype.setReturnSettings = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_config.SafeLandingPoint} returns this
 */
proto.cloud_config.SafeLandingPoint.prototype.clearReturnSettings = function() {
  return this.setReturnSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_config.SafeLandingPoint.prototype.hasReturnSettings = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_config.GeofenceLock.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_config.GeofenceLock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_config.GeofenceLock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.GeofenceLock.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_config.GeofenceLock}
 */
proto.cloud_config.GeofenceLock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_config.GeofenceLock;
  return proto.cloud_config.GeofenceLock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_config.GeofenceLock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_config.GeofenceLock}
 */
proto.cloud_config.GeofenceLock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_config.GeofenceLock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_config.GeofenceLock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_config.GeofenceLock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.GeofenceLock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.cloud_config.GeofenceLock.Enum = {
  UNLOCKED: 0,
  LOCKED: 1
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_config.GeofenceEnforcement.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_config.GeofenceEnforcement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_config.GeofenceEnforcement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.GeofenceEnforcement.toObject = function(includeInstance, msg) {
  var f, obj = {
enforcementMode: jspb.Message.getFieldWithDefault(msg, 1, 0),
lock: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_config.GeofenceEnforcement}
 */
proto.cloud_config.GeofenceEnforcement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_config.GeofenceEnforcement;
  return proto.cloud_config.GeofenceEnforcement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_config.GeofenceEnforcement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_config.GeofenceEnforcement}
 */
proto.cloud_config.GeofenceEnforcement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.cloud_config.GeofenceLayer} */ (reader.readEnum());
      msg.setEnforcementMode(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud_config.GeofenceLock.Enum} */ (reader.readEnum());
      msg.setLock(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_config.GeofenceEnforcement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_config.GeofenceEnforcement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_config.GeofenceEnforcement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_config.GeofenceEnforcement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnforcementMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLock();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional GeofenceLayer enforcement_mode = 1;
 * @return {!proto.cloud_config.GeofenceLayer}
 */
proto.cloud_config.GeofenceEnforcement.prototype.getEnforcementMode = function() {
  return /** @type {!proto.cloud_config.GeofenceLayer} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.cloud_config.GeofenceLayer} value
 * @return {!proto.cloud_config.GeofenceEnforcement} returns this
 */
proto.cloud_config.GeofenceEnforcement.prototype.setEnforcementMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional GeofenceLock.Enum lock = 2;
 * @return {!proto.cloud_config.GeofenceLock.Enum}
 */
proto.cloud_config.GeofenceEnforcement.prototype.getLock = function() {
  return /** @type {!proto.cloud_config.GeofenceLock.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud_config.GeofenceLock.Enum} value
 * @return {!proto.cloud_config.GeofenceEnforcement} returns this
 */
proto.cloud_config.GeofenceEnforcement.prototype.setLock = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.cloud_config.GeofenceLayer = {
  OFF: 0,
  BASE: 1,
  AUTONOMOUS: 2,
  WARNING: 3
};

goog.object.extend(exports, proto.cloud_config);
